// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "disturbance-frontend/js/" + chunkId + "." + {"346":"1295c2c4670363d2a1ff","634":"f36452ba76c1a56e05b1","902":"2e95e7c9cf6367ccb07d"}[chunkId] + ".bundle.js";
};